import { render } from "./AdminCategories.vue?vue&type=template&id=cf70fcba&scoped=true"
import script from "./AdminCategories.vue?vue&type=script&lang=js"
export * from "./AdminCategories.vue?vue&type=script&lang=js"

import "./AdminCategories.vue?vue&type=style&index=0&id=cf70fcba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf70fcba"]])

export default __exports__